import { Slider } from "antd";
import { Modal, DropdownButton, Dropdown } from "react-bootstrap";

import cursor1 from "../../assets/crosshair_1.png";
import cursor2 from "../../assets/crosshair_2.png";
import cursor3 from "../../assets/crosshair_3.png";
import cursor4 from "../../assets/crosshair.png";
import cursor5 from "../../assets/simple_dot.png";
import close from "../../assets/close.png";
import reset from "../../assets/reset_data.png";
import resetHover from "../../assets/reset_dataHover.png";
import playAgain from "../../assets/play_again.png";
import playAgainHover from "../../assets/play_againHover.png";

const PrecisionSettings = (props) => {
  const handleSelect = (event) => {
    console.log(`selected ${event}`);
    if (event === "1")
      document.getElementById("canvas").className =
        "precision-canvas mouse-cursor-1";
    else if (event === "2")
      document.getElementById("canvas").className =
        "precision-canvas mouse-cursor-2";
    else if (event === "3")
      document.getElementById("canvas").className =
        "precision-canvas mouse-cursor-3";
    else if (event === "4")
      document.getElementById("canvas").className =
        "precision-canvas mouse-cursor-4";
    else if (event === "5")
      document.getElementById("canvas").className =
        "custom-canvas mouse-cursor-5";
    else if (event === "6")
      document.getElementById("canvas").className =
        "custom-canvas mouse-cursor-6";
  };
  return (
    <>
      <Modal
        id="precision"
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={props.isSettingsOpen}
        onHide={() => props.setIsSettingsOpen(false)}
        style={{ border: "none" }}
      >
        <Modal.Header
          style={{
            borderColor: "transparent",
            textAlign: "right",
          }}
        >
          <Modal.Title
            id="contained-modal-title-hcenter"
            style={{
              margin: "auto",
              color: "white",
            }}
          >
            Settings
          </Modal.Title>
          <img
            src={close}
            alt="close"
            width={22}
            onClick={() => props.setIsSettingsOpen(false)}
            style={{ transform: "translate(60%,-200%)" }}
          ></img>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex flex-column justify-content-start align-items-center m-0"
            style={{
              backgroundColor: "#0a1325",
              color: "white",
              fontSize: "large",
              fontWeight: "700",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mt-4 w-100 ">
              <span>Spawning target after </span>
              <Slider
                style={{ width: 200 }}
                defaultValue={props.speed}
                onChange={(value) => {
                  props.setSpeed(value);
                }}
                tipFormatter={(value) => `${value} ms`}
                step={100}
                min={100}
                max={5000}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-4 w-100 ">
              <span>Target Size</span>
              <Slider
                style={{ width: 200 }}
                defaultValue={props.targetSize}
                onChange={(value) => {
                  props.setTargetSize(value);
                }}
                step={1}
                min={7}
                max={20}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-4 w-100 ">
              <span>Crosshair Type</span>
              <DropdownButton
                id="dropdown-basic-button"
                title="Select"
                style={{ backgroundColor: "#0a1325" }}
                onSelect={handleSelect}
              >
                <Dropdown.Item eventKey="1">
                  <img
                    src={cursor1}
                    alt="cursor1"
                    width={25}
                    style={{ float: "left" }}
                  ></img>
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Trigger Pointer
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="2">
                  <img
                    src={cursor2}
                    alt="cursor2"
                    width={20}
                    style={{ float: "left" }}
                  ></img>
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Crosshair
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="3">
                  <img
                    src={cursor3}
                    alt="cursor3"
                    width={20}
                    style={{ float: "left" }}
                  ></img>
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Dot
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="4">
                  <img
                    src={cursor4}
                    alt="cursor4"
                    width={20}
                    style={{ float: "left" }}
                  ></img>
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Simple Crosshair
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="5">
                  <img
                    src={cursor5}
                    alt="cursor5"
                    width={20}
                    style={{ float: "left" }}
                  ></img>
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Simple Dot
                  </div>
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item eventKey="6">
                  <div className="mx-5" style={{ textAlign: "left" }}>
                    Default Crosshair
                  </div>
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </div>
          <div
            className="d-flex flex-row justify-content-center align-items-center"
            style={{ transform: "translateY(28%)" }}
          >
            <img
              src={playAgain}
              width={250}
              onClick={() => {
                props.setIsSettingsOpen(false);
                props.startGame();
              }}
              onMouseOver={(e) => {
                e.currentTarget.src = playAgainHover;
              }}
              onMouseOut={(e) => {
                e.currentTarget.src = playAgain;
              }}
              alt="playAgain"
              style={{ margin: "20px" }}
            ></img>

            <img
              src={reset}
              width={250}
              onMouseOver={(e) => {
                e.currentTarget.src = resetHover;
              }}
              onMouseOut={(e) => {
                e.currentTarget.src = reset;
              }}
              onClick={() => {
                props.setSpeed(1000);
                props.setTargetSize(12);
                document.getElementById("canvas").className =
                  "precision-canvas mouse-cursor-4";
                props.setIsSettingsOpen(false);
              }}
              alt="reset"
              style={{ margin: "20px" }}
            ></img>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PrecisionSettings;
